module.exports = __webpack_public_path__ + "img/wh-li-icon2.1653a3f4.png";